import * as Sentry from "@sentry/react";
import React from 'react';
import ReactDOM from 'react-dom/client';
import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import './index.css';
import AppWrapper from './AppWrapper';
import { ImpersonationBanner } from './components/ImpersonationBanner';

Sentry.init({
  dsn: "https://345e80fb3d4355925f7830be9b5c13e1@o4507608582062080.ingest.us.sentry.io/4509789438083072",
  environment: process.env.REACT_APP_ENV || 'dev',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  tracesSampleRate: process.env.REACT_APP_ENV === 'prod' ? 0.1 : 1.0,
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


root.render(
  <React.StrictMode>
    {/* Global impersonation banner so it appears on all pages */}
    <ImpersonationBanner />
    <AppWrapper />
  </React.StrictMode>
);